import { OktaAuth } from '@okta/okta-auth-js'
import { clearUnloadSuppression, suppressUnloadPrompt } from '../utils/unloadGuard'

// Okta configuration
const oktaConfig = {
  issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://dev-123456.okta.com/oauth2/default',
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID || 'demo-client-id',
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI || `${window.location.origin}/login/callback`,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  responseType: 'code',
  // Let React Router navigate after OktaCallback runs; required for signInWithRedirect + PKCE
  restoreOriginalUri: async () => {}
}

// Create Okta Auth instance
const oktaAuth = new OktaAuth(oktaConfig)

// Okta sign-in function
export const signInWithOkta = async () => {
  try {
    suppressUnloadPrompt()
    await oktaAuth.signInWithRedirect()
  } catch (error) {
    clearUnloadSuppression()
    console.error('Okta sign-in error:', error)
    throw error
  }
}

// Get Okta user info
export const getOktaUser = async () => {
  try {
    const user = await oktaAuth.getUser()
    return user
  } catch (error) {
    console.error('Get Okta user error:', error)
    throw error
  }
}

// Okta sign-out function
export const signOutOkta = async () => {
  try {
    suppressUnloadPrompt()
    await oktaAuth.signOut()
  } catch (error) {
    clearUnloadSuppression()
    console.error('Okta sign-out error:', error)
    throw error
  }
}

// Check if user is authenticated with Okta
export const isOktaAuthenticated = async () => {
  try {
    const isAuthenticated = await oktaAuth.isAuthenticated()
    return isAuthenticated
  } catch (error) {
    console.error('Okta authentication check error:', error)
    return false
  }
}

export { oktaAuth, oktaConfig }
export default oktaAuth
